module.exports = __webpack_public_path__ + "img/rtf.22546818.png";